import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/authContext';
import { useFirebase } from '../../context/firebaseContext';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { 
  Mail,
  User, 
  Settings, 
  ArrowLeft,
  BookOpen
} from 'lucide-react';

const MobileNavbarModern = () => {
  const { user } = useAuth();
  const { db } = useFirebase();
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
      const fetchUsername = async () => {
          if (user?.uid) {
              try {
                  const userDocRef = doc(db, 'users', user.uid);
                  const userDoc = await getDoc(userDocRef);
                  
                  if (userDoc.exists()) {
                      const userData = userDoc.data();
                      setUserData(userData);
                  }
              } catch (error) {
                  console.error('Error fetching username:', error);
                  setUserData({ username: 'User' });
              }
          }
      };
      
      fetchUsername();
  }, [user, db]);
  
  const getPageTitle = () => {
      // Special case for dashboard - show welcome message
      if (location.pathname === '/' || location.pathname === '/mobile') {
          return '';
      }
      
      switch (location.pathname) {
          case '/mobile/academy':
              return 'Academy';
          case '/academy':
              return 'Academy';
          case '/study':
              return 'Study Center';
          case '/tools':
              return 'Mystic Tools';
          case '/settings':
              return 'Settings';
          case '/profile':
              return 'Profile';
          case '/progress':
              return 'Progress';
          case '/mobile/progress':
              return 'Progress';
          case '/studytools':
              return 'Study Tools';
          case '/library':
              return 'Library';
          default:
              return '';
      }
  };

  const shouldShowBackButton = () => {
      // Don't show back button on dashboard
      if (location.pathname === '/' || location.pathname === '/mobile') {
          return false;
      }
      
      // Show back button on all other pages
      return true;
  };

  const handleBackClick = () => {
      console.log('Back button clicked, current path:', location.pathname);
      navigate(-1);
  };

  // Removed unused function: handleSettingsClick

  console.log('Current path:', location.pathname, 'Should show back button:', shouldShowBackButton());

  return (
      <div className="mobile-navbar-modern">
          {shouldShowBackButton() && (
              <button className="navbar-back-button" onClick={handleBackClick}>
                  <ArrowLeft size={20} />
              </button>
          )}
          <div className="navbar-title">
              {getPageTitle()}
          </div>
          <div className="navbar-actions">
              <Link to="/messages" className="navbar-icon">
                  <Mail size={20} />
              </Link>
              <Link to="/mobile/journal" className="navbar-icon">
                  <BookOpen size={20} />
              </Link>
              <Link to="/profile" className="navbar-icon">
                  <User size={20} />
              </Link>
              <Link to="/settings" className="navbar-icon">
                  <Settings size={20} />
              </Link>
          </div>
      </div>
  );
}

export default MobileNavbarModern; 
